import React from 'react';
import {Link, NavLink} from "react-router-dom";

export const Nav = () => {
     return (
         <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
             <div className="container">
                 <Link className="navbar-brand" to={"/"}><span style={{ fontWeight: 550 }}>Marc E. Canby</span></Link>
                 <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
                 <div className="collapse navbar-collapse" id="navbarSupportedContent">
                     <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                         <li className="nav-item"><NavLink className="nav-link" aria-current="page" to={"/"}><span style={{ fontWeight: 550 }}>Home</span></NavLink></li>
                         <li className="nav-item"><NavLink className="nav-link" to={"/publications"}><span style={{ fontWeight: 550 }}>Publications</span></NavLink></li>
                         {/*<li className="nav-item dropdown">*/}
                         {/*    <a className="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Dropdown</a>*/}
                         {/*    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">*/}
                         {/*        <li><a className="dropdown-item" href="#">Action</a></li>*/}
                         {/*        <li><a className="dropdown-item" href="#">Another action</a></li>*/}
                         {/*        <li><hr className="dropdown-divider" /></li>*/}
                         {/*        <li><a className="dropdown-item" href="#">Something else here</a></li>*/}
                         {/*    </ul>*/}
                         {/*</li>*/}
                     </ul>
                 </div>
             </div>
         </nav>
     )
}